import React, { useState } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createNullableDateTimeFromBackendDate } from '../../util/dateUtil';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import '../../style/DataTable.css';
import { formatBackendDateEtLocale } from '../../util/dateUtil';
import { isForfeitMatch, forfeitScore } from '../../util/forfeitUtil';
import useDebouncedValue from '../../util/useDebouncedValue';

const AllMatchesDataTable = (props) => {
  // Debounced client-side search (only when the caller opted into searching). Debouncing +
  // disabling MDBDataTable's own synchronous search keeps filtering a large match list from
  // re-filtering on every keystroke.
  const [search, setSearch] = useState('');
  const q = useDebouncedValue(search, 300).trim().toLowerCase();
  const getAllMatchesData = () => {
    let rowData = [];
    props.allMatches
      .sort(
        (a, b) =>
          (createNullableDateTimeFromBackendDate(a.matchDateTime) || 0) -
          (createNullableDateTimeFromBackendDate(b.matchDateTime) || 0)
      )
      .forEach((row) => {
        rowData.push({
          leagueName: row.leagueName ? row.leagueName : 'N/A',
          seasonName: row.seasonName ? row.seasonName : 'N/A',
          homeTeamName: row.homeTeamName ? row.homeTeamName : 'N/A',
          awayTeamName: row.awayTeamName ? row.awayTeamName : 'N/A',
          matchDateTime: row.matchDateTime
            ? formatBackendDateEtLocale(row.matchDateTime)
            : 'N/A',
          combinedPoints: isForfeitMatch(row)
            ? forfeitScore(row)
            : row.homePoints !== null
            ? `${row.homePoints}:${row.awayPoints} (${row.homeTotal}:${row.awayTotal})`
            : 'N/A',
          toDetails:
            row.homePoints !== null ? (
              <Link to={`/admin/match_details?match_id=${row.id}`}>
                <FontAwesomeIcon icon={faEye} />
              </Link>
            ) : (
              <Link to={`/admin/add_match?match_id=${row.id}`}>
                <FontAwesomeIcon icon={faEdit} />
              </Link>
            ),
        });
      });
    if (!rowData.length) {
      return null;
    }

    return {
      columns: [
        {
          label: 'Hooaeg',
          field: 'seasonName',
        },
        {
          label: 'Liiga',
          field: 'leagueName',
        },
        {
          label: 'Koduvõistkond',
          field: 'homeTeamName',
        },
        {
          label: 'Külalisvõistkond',
          field: 'awayTeamName',
        },
        {
          label: 'Aeg',
          field: 'matchDateTime',
        },
        {
          label: 'Tulemus',
          field: 'combinedPoints',
        },
        {
          label: 'Detailid',
          field: 'toDetails',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getAllMatchesData();
  // Filter the built rows across their visible text columns (mirrors MDB's cross-column search).
  if (tableData && props.searching && q) {
    tableData.rows = tableData.rows.filter((row) =>
      Object.values(row).some(
        (v) => typeof v === 'string' && v.toLowerCase().includes(q)
      )
    );
  }

  return (
    <div>
      {props.searching && (
        <input
          type='text'
          className='form-control mb-2'
          style={{ maxWidth: '320px' }}
          placeholder='Otsi'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      )}
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          bordered={false}
          paging={!!props.paging}
          searching={false}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>
          {props.searching && q ? 'Tulemusi ei leitud' : 'Info puudub'}
        </div>
      )}
    </div>
  );
};

export default AllMatchesDataTable;
